import RefundPolicyPage from "pages/legal/RefundPolicyPage";
import React from "react";

const RefundPolicyRoute = () => <RefundPolicyPage />;

export default RefundPolicyRoute;
